<div class="flex flex-wrap justify-end gap-4 filters-wrapper">
  <!-- <button
    class="py-1 px-5 border border-[#d9d9d9] rounded"
    (click)="onGroupExclusionClick()"
    [disabled]="selectedTag.length < 2"
    [ngClass]="{
      'bg-[#1f273b] text-white cursor-pointer hover:bg-[#2a334a]':
        selectedTag.length >= 2,
      'bg-white text-gray-800 cursor-not-allowed': selectedTag.length < 2
    }"
    pTooltip="{{
      selectedTag.length < 2
        ? 'Select at least two rows to enable grouping'
        : ''
    }}"
    tooltipPosition="top"
  >
    Group Exclusion
  </button> -->
  <!-- <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="filingId"
    type="text"
    placeholder="Search by filing Id"
    class="border-b-1 text-sm border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
  /> -->

  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="issuerName"
    type="text"
    placeholder="Search by issuer name"
    class="border-b-1 text-sm border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
  />
  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="insiderName"
    type="text"
    placeholder="Search by insider name"
    class="border-b-1 text-sm border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
  />
</div>
<div class="mb-4"></div>

<p-table
  [value]="unprocessedPlanLinkageEntries"
  [paginator]="unprocessedPlanLinkageEntries.length > 0"
  [first]="first"
  selectionMode="single"
  (onLazyLoad)="loadData($event)"
  [lazy]="true"
  [totalRecords]="paginator.totalCount"
  [rows]="paginator.pageSize"
  [loading]="isLoading"
  [showCurrentPageReport]="true"
  [tableStyle]="{ 'min-width': '50rem' }"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  (onPage)="pageChange($event)"
  [(selection)]="selectedTag"
  dataKey="entryId"
  [rowsPerPageOptions]="[10, 25, 50]">

  <ng-template #header>
    <tr>
      <th>Issuer Name</th>
      <th>Insider Name</th>
      <th>Plan Action</th>
      <th>Reference Date</th>
    </tr>
  </ng-template>
  <ng-template #body let-share>
    <tr  [ngClass]="{
          'highlight-plan-row': share.tradingPlanStatus === 'DUPLICATE'
        }"
         (click)="openPlanLinkageModal(share)" class="cursor-pointer">
      <td>{{ share.issuerName || "N/A" }}</td>
      <td>{{ share.insiderName || "N/A" }}</td>
      <td>{{ share.planAction || "N/A" }}</td>
      <td>{{ share.referenceDate || "N/A" }}</td>
    </tr>
  </ng-template>
</p-table>

<ng-container
  *ngIf="!isLoading && unprocessedPlanLinkageEntries.length === 0"
>
  <div class="text-center py-6 text-gray-500">No record found</div>
</ng-container>
